export default __webpack_public_path__ + "static/media/news14.a002ba08.jpg";